/*
* Copyright (C) Regione Lombardia
*/
import { AfterContentChecked, AfterViewInit, Component, ElementRef, Input, OnInit, Renderer2, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import {
    AnagraficaComuni,
    AnagraficaTipologiaOpera,
    DatalistAnagrafica
} from '@models';
import { NgbTypeaheadSelectItemEvent } from '@ng-bootstrap/ng-bootstrap';
import { OperaService } from '@shared/services/opera.service';
import { debounceTime, distinctUntilChanged, map, Observable, OperatorFunction } from 'rxjs';




@Component({
    selector: 'app-toolkit-opera-tab-anagrafica-opera',
    templateUrl: './tab-anagrafica-opera.component.html',
})
export class ToolkitGestioneOperaTabAnagraficaOperaComponent implements OnInit, AfterViewInit {



    @ViewChild('inputComuni') inputComuni: ElementRef;

    @Input() canEdit: boolean;
    @Input() formGroup: FormGroup;
    @Input() datalist: DatalistAnagrafica;

    public comuniFiltered: AnagraficaComuni[] = [];
    public tipologiaOperaFiltered: AnagraficaTipologiaOpera[] = [];

    constructor(
        public operaService: OperaService,
        private renderer: Renderer2
    ) { }

    ngOnInit() {
        if (this.canEdit === false) {
            this.formGroup.disable();
        }



        this.checkClassificazione();
        this.searchComuniByProvincia();
        // this.searchTipologiaOperaByMacroTipologiaOpera();
        this.searchTipologiaOperaByClassificazioneOpera();
        this.setMacrotipologiaByTipologiaOpera();
    }

    /* Provincia: filtro per comuni */
    public searchComuniByProvincia() {
        if (this.formGroup.value.codProv === null) {
            this.formGroup.controls['comune'].setValue(null);
            this.formGroup.controls['codIstat'].setValue(null);
            this.formGroup.controls['comune'].disable();
            this.comuniFiltered = [...(this.datalist.comuni || [])];
        } else {
            this.comuniFiltered = [...(this.datalist.comuni || [])].filter((i: AnagraficaComuni) =>
                i.extra1 === this.formGroup.value.codProv
            );
            if (this.formGroup.get('codIstat')?.value && !this.comuniFiltered.find(f =>
                f.id === this.formGroup.get('codIstat')?.value)) {
                this.formGroup.controls['codIstat'].setValue(null);
                this.formGroup.controls['comune'].setValue(null);
            }
            if (this.canEdit) {
                this.formGroup.controls['comune'].enable();
            }
        }
    }

    /* Comuni: Typeahead */
    public filterComuni: OperatorFunction<string, readonly any[]> = (text$: Observable<string>) => text$.pipe(
        debounceTime(200),
        distinctUntilChanged(),
        map((term) => {
            if (!term) {
                this.formGroup.get('codIstat')?.reset()
            }
            return this.comuniFiltered.filter((i: AnagraficaComuni) => new RegExp(term, 'mi').test(i.descrizione)).slice(0, 10)
        }),
    );
    public selectItemComuni(event: NgbTypeaheadSelectItemEvent) {
        this.formGroup.controls['codIstat'].setValue(event.item.id);
    }

    // /* Categoria opera: filtro per tipologia opera */
    // public searchTipologiaOperaByMacroTipologiaOpera() {
    //     if (this.formGroup.value.macroTipologiaOpera === null) {
    //         this.formGroup.controls['idTipologiaOpera'].setValue(null);
    //         this.formGroup.controls['idTipologiaOpera'].disable();
    //         this.tipologiaOperaFiltered = [...(this.datalist.tipologiaOpera || [])];
    //     } else {
    //         this.tipologiaOperaFiltered = [...(this.datalist.tipologiaOpera || [])].filter((i: AnagraficaTipologiaOpera) =>
    //             i.idMacroTipologia.id === this.formGroup.value.macroTipologiaOpera
    //         );
    //         if (this.canEdit) {
    //             this.formGroup.controls['idTipologiaOpera'].enable();
    //         }

    //         /*set funzione prevalente */
    //         this.formGroup.get('idFunzionePrevalente')?.setValue( this.datalist.macroTipologiaOpera?.find(f=> f.id === this.formGroup.value.macroTipologiaOpera)?.idFunzionePrevalente);
    //     }
    // }


    public checkClassificazione() {

        if (this.formGroup.value.classificazioneOpera === null){
        
        if (this.formGroup.controls['idTipologiaOpera'].value !== null) {

            this.formGroup.get('classificazioneOpera')?.setValue(this.datalist.tipologiaOpera?.find(f => f.idTipologiaOpera === this.formGroup.value.idTipologiaOpera)?.idClassificazioneOpera.id)
            
        }
    }
    }
    /* Tipologia opera: filtro per Classificazione opera: */
    public searchTipologiaOperaByClassificazioneOpera() {


        if (this.formGroup.value.classificazioneOpera === null) {


            //   this.formGroup.controls['idTipologiaOpera'].setValue(null);
            this.formGroup.controls['idTipologiaOpera'].disable();
            // this.formGroup.controls['macroTipologiaOpera'].setValue(null);
            this.formGroup.controls['macroTipologiaOpera'].disable();
            // this.formGroup.controls['idFunzionePrevalente'].setValue(null);
            this.formGroup.controls['idFunzionePrevalente'].disable();
           this.tipologiaOperaFiltered = [...(this.datalist.tipologiaOpera || [])];
        } else {
            this.tipologiaOperaFiltered = [...(this.datalist.tipologiaOpera || [])].filter((i: AnagraficaTipologiaOpera) =>
                i.idClassificazioneOpera.id === this.formGroup.value.classificazioneOpera
            );
            if (this.canEdit) {
                this.formGroup.controls['idTipologiaOpera'].enable();
            }


        }
    }



    /* Funzione che imposta in automatico i valori di Macrotipologia e Funzione prevalente 
    all'inserimento della Tipologia Opera */

    public setMacrotipologiaByTipologiaOpera() {

        this.formGroup.get('idFunzionePrevalente')?.setValue(this.datalist.tipologiaOpera?.find(f => f.idTipologiaOpera === this.formGroup.value.idTipologiaOpera)?.idFunzionePrevalente.id)
        this.formGroup.get('macroTipologiaOpera')?.setValue(this.datalist.tipologiaOpera?.find(f => f.idTipologiaOpera === this.formGroup.value.idTipologiaOpera)?.idMacroTipologia.id);

    }

    /* Funzione che permette di recuperare il valore del campo provenienza per passarlo al tooltip */


    public getProvenienza() {

        return this.formGroup.value.provenienza;

    }




    public comuneFormatter = (result: any) => {
        if (result.descrizione) {
            return result.descrizione;
        }
        return this.comuniFiltered.find(f => f.id === result)?.descrizione;
    };

    //Accessibility

    ngAfterViewInit(): void {
        if (this.inputComuni !== undefined) {
            this.renderer.removeAttribute(this.inputComuni.nativeElement, 'aria-multiline');
        }
    }




}



